import store from 'store';

import { setContext } from 'apollo-link-context';
import URLSearchParams from '@ungap/url-search-params';

import { fetchAccessToken } from 'actions/gallery';

// Add authorization and device wireId to context
const getDeviceContext = async (request, previousContext) => {
  const headers = {};
  const queryParams = new URLSearchParams();

  await store.dispatch(fetchAccessToken());
  const { accessToken, deviceInfo } = store.getState().gallery;

  if (accessToken) {
    headers.authorization = `Bearer ${accessToken}`;
  }

  if (deviceInfo && deviceInfo.wireId) {
    queryParams.set('wireId', deviceInfo.wireId);
  }

  return {
    headers: {
      ...previousContext.headers,
      ...headers
    },
    fetchOptions: {
      ...previousContext.fetchOptions,
      urlSearchParams: queryParams
    }
  };
};

export const createMiddlewareLink = () => setContext(getDeviceContext);
